export class UnprocessableEntityError extends Error {
  constructor(readonly error: Error) {
    super(error.message)
    Object.setPrototypeOf(this, UnprocessableEntityError.prototype)
  }
}
